import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";
import { LogChange } from "../types/logs/change.type";
import { formatDateTime } from "../utils/formatters";
import ChangesColumn from "../components/LogChangesTable/components/ChangesColumn";

interface TableTransformerOptions {
  basePath?: string;
}

const sanitizeBasePath = (basePath?: string) => {
  if (!basePath) return "";

  return basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;
};

export class LogChangesTransformer {
  static tableTransformer({ basePath }: TableTransformerOptions = {}) {
    const sanitizedBasePath = sanitizeBasePath(basePath);

    return (logChanges: LogChange[]) => {
      return logChanges.map((log) => {
        const hasRequest = Boolean(log.request_id);
        const linkTo = hasRequest
          ? sanitizedBasePath
            ? `${sanitizedBasePath}/${log.request_id}`
            : log.request_id
          : undefined;

        return {
          ...log,
          created_at: formatDateTime(new Date(log.created_at)),
          item_name_translated: log.item_name_translated,
          changes: <ChangesColumn id={log.id} changes={log.object_changes_translated} />,
          actions: hasRequest && linkTo ? (
            <Link to={linkTo}>
              <ArrowBigRight />
            </Link>
          ) : null,
        };
      });
    };
  }
}
